import { BaseApiService, unwrapApiResponse } from './base';

export interface AuthMeResponse {
  email: string;
  role: string;
  groups: string[];
  userId?: string;
  displayName?: string;
  givenName?: string;
  familyName?: string;
}

export interface RoleMappingResponse {
  groupName: string;
  role: string;
  description?: string;
  cognitoDescription?: string;
  updatedAt?: string;
  updatedBy?: string;
  locked?: boolean;
}

export interface RoleMappingsFullResponse {
  mappings: RoleMappingResponse[];
  availableRoles: string[];
  knownGroups: string[];
}

class RbacApiService extends BaseApiService {
  async getAuthMe(): Promise<AuthMeResponse> {
    const response = await this.get('/auth/me');
    const data = await response.json();
    return unwrapApiResponse<AuthMeResponse>(data);
  }

  async getRoleMappings(): Promise<RoleMappingResponse[]> {
    const response = await this.get('/admin/role-mappings');
    const data = await response.json();
    const unwrapped = unwrapApiResponse<any>(data);
    // API returns { mappings: [...], availableRoles: [...], knownGroups: [...] }
    return unwrapped.mappings || unwrapped;
  }

  async getRoleMappingsFull(): Promise<RoleMappingsFullResponse> {
    const response = await this.get('/admin/role-mappings');
    const data = await response.json();
    const unwrapped = unwrapApiResponse<any>(data);
    return {
      mappings: unwrapped.mappings || [],
      availableRoles: unwrapped.availableRoles || [],
      knownGroups: unwrapped.knownGroups || [],
    };
  }

  async updateRoleMapping(groupName: string, role: string): Promise<RoleMappingResponse> {
    const response = await this.put(`/admin/role-mappings/${encodeURIComponent(groupName)}`, { role });
    const data = await response.json();
    return unwrapApiResponse<RoleMappingResponse>(data);
  }

  async deleteRoleMapping(groupName: string): Promise<void> {
    await this.delete(`/admin/role-mappings/${encodeURIComponent(groupName)}`);
  }
}

export const rbacApi = new RbacApiService();
